
import { Box, Button, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import BoxesListSelect from './BoxesListSelect'
import IncreaseDecreaseInput from './IncreaseDecreaseInput'
import { useTranslation } from 'react-i18next'
import { Delete } from '@mui/icons-material'
import { get } from 'lodash'

export default function ShipmentBoxesList({
    boxes = [],
    onChange,
    errors,
    hideSelectBoxes = false
}) {
    const { t } = useTranslation()

    const handleChange = ({ target: { name, value } }) => {
        let [boxIndex, boxKey] = name.split("-").slice(1)
        let newBoxes = [...boxes]
        if (boxKey !== "weight") {
            newBoxes[boxIndex] = { ...newBoxes[boxIndex], dimensions: { ...newBoxes[boxIndex]?.dimensions, [boxKey]: value } }
        } else {
            newBoxes[boxIndex] = { ...newBoxes[boxIndex], weight: value }
        }
        onChange({ target: { name: "boxes", value: newBoxes } })
    }

    const handleSelectBox = ({ target: { name, value } }) => {
        let boxIndex = name.split("-")[1]
        let newBoxes = [...boxes]
        newBoxes[boxIndex] = { dimensions: { ...value?.dimensions }, weight: value?.weight ?? 1 }
        onChange({ target: { name: "boxes", value: newBoxes } })
    }


    const deleteBoxHandler = (index) => {
        let newBoxes = [...boxes]
        newBoxes.splice(index, 1)
        onChange({ target: { name: "boxes", value: newBoxes } })
    }

    const isDownLgScreen = useMediaQuery((theme) => theme.breakpoints.down('lg'))

    return (
        <Box>
            {boxes.map((box, index) => (
                <Grid key={index} container spacing={0.5} alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                    {!hideSelectBoxes &&
                        <Grid item xs={12} sm={10} md={7} lg={3}>
                            <BoxesListSelect
                                boxValue={box}
                                name={`box-${index}`}
                                selectDefaultBoxAuto={false}
                                onChange={(value) => handleSelectBox({ target: { name: `box-${index}`, value } })}
                            />
                        </Grid>
                    }
                    <Grid item xs={10} sm={6} md={6} lg={2}>
                        <IncreaseDecreaseInput
                            decimal={false}
                            max={999999}
                            adornment={t("cm")}
                            label={t("Length")}
                            value={box?.dimensions?.length}
                            onChange={handleChange}
                            name={`box-${index}-length`}
                            error={get(errors, `${index}.dimensions.length`) ?? null}
                        />
                    </Grid>
                    <Grid item xs={10} sm={6} md={6} lg={2}>
                        <IncreaseDecreaseInput
                            decimal={false}
                            max={999999}
                            adornment={t("cm")}
                            label={t("Width")}
                            value={box?.dimensions?.width}
                            onChange={handleChange}
                            name={`box-${index}-width`}
                            error={get(errors, `${index}.dimensions.width`) ?? null}
                        />
                    </Grid>
                    <Grid item xs={10} sm={6} md={6} lg={2}>
                        <IncreaseDecreaseInput
                            decimal={false}
                            max={999999}
                            adornment={t("cm")}
                            label={t("Height")}
                            value={box?.dimensions?.height}
                            onChange={handleChange}
                            name={`box-${index}-height`}
                            error={get(errors, `${index}.dimensions.height`) ?? null}
                        />
                    </Grid>
                    <Grid item xs={10} sm={6} md={6} lg={2}>
                        <IncreaseDecreaseInput
                            max={999999}
                            adornment={t("kg")}
                            label={t("Weight")}
                            value={box?.weight}
                            onChange={handleChange}
                            name={`box-${index}-weight`}
                            error={get(errors, `${index}.weight`) ?? null}
                        />
                    </Grid>
                    <Grid item xs={5} sm={4} md={4} lg={0.5} alignSelf="center">
                        <Box mt={{ md: 0, lg: 2.7 }}>
                            {
                                isDownLgScreen ?
                                    <Button
                                        onClick={() => deleteBoxHandler(index)}
                                        disabled={boxes?.length <= 1}
                                        size="small"
                                        sx={{ textTransform: "none" }}
                                        variant="outlined"
                                        color='error'
                                        startIcon={<Delete />}
                                    >
                                        {t("Delete Box")}
                                    </Button>
                                    :
                                    <Button
                                        onClick={() => deleteBoxHandler(index)}
                                        disabled={boxes?.length <= 1}
                                        size="small"
                                        sx={{ px: 0, minWidth: 1 }}
                                        variant="outlined"
                                        color='error'
                                    >
                                        <Delete />
                                    </Button>
                            }
                        </Box>
                    </Grid>
                </Grid>
            ))
            }
        </Box >
    )
}
